import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';

export interface EnvironmentalCondition {
  readonly pkAreaRiskResult: string;
  readonly riskCategoryId: number;
  readonly riskTypeId: number;
  readonly riskTypeName: string;
  readonly riskValue: number;
  readonly riskName: string;
  readonly pkAreaRiskCategoryRankType: number;
  readonly areaId: string;
  readonly dateModified: string;
  readonly dateCreated?: string;
  readonly site: number;
}

export const environmentalConditionSchema: RxJsonSchema<EnvironmentalCondition> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'pkAreaRiskResult',
  properties: {
    pkAreaRiskResult: { type: 'string', maxLength: 36 },
    riskCategoryId: { type: ['number', 'null'] },
    riskTypeId: { type: ['number'] },
    riskTypeName: { type: 'string' },
    riskValue: { type: ['number', 'null'] },
    riskName: { type: 'string' },
    pkAreaRiskCategoryRankType: { type: ['number', 'null'] },
    areaId: { type: 'string' },
    dateModified: { type: ['string', 'null'] },
    site: { type: ['number'] },
  },
};

export type EnvironmentalConditionCollection = RxCollection<EnvironmentalCondition> | null;
export type EnvironmentalConditionDocument = RxDocument<EnvironmentalCondition>;

export const environmentalConditionPullQueryBuilder = (document: EnvironmentalCondition) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query areasEnvironmentConditionBySite($site: Int!, $lastRequested: DateTime!) {
      areasEnvironmentConditionBySite(site: $site, lastRequested: $lastRequested) {
        pkAreaRiskResult
        riskCategoryId
        pkAreaRiskCategoryRankType
        riskName
        riskValue
        riskTypeId
        riskTypeName
        areaId
        dateModified
        site
      }
    }
  `);

  return {
    query,
    variables: {
      site: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};

export default {};
